/** Roles that may send feedback: every signed-in team member (a customer account is not one). */
export const FEEDBACK_ROLES = ['admin', 'staff', 'estimator', 'crew'];
